<template>
  <div>
    <a-alert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <!-- filter -->
    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterOpco style="width:100%;" v-model:value="state.params.opco" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterProvince style="width:100%;" v-model:value="state.params.provinsi" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterArea
          style="width:100%;"
          v-model:value="state.params.area"
          v-model:provinsi="state.params.provinsi"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterKabupatenKota
          style="width:100%;"
          v-model:value="state.params.kabupaten"
          v-model:provinsi="state.params.provinsi"
          v-model:area="state.params.area"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterDistributor
          style="width:100%;"
          v-model:value="state.params.distributor"
          v-model:distributor="state.params.distributor"
          v-model:area="state.params.area"
          v-model:provinsi="state.params.provinsi"
          v-model:kabupaten="state.params.kabupaten"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterToko style="width:100%;" v-model:value="state.params.toko" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AMonthPicker
          style="width:100%;"
          v-model:value="state.params.periode"
          :disabled-date="disabledDateMonthFilter"
          :allow-clear="false"
          placeholder="Pilih Periode"
          format="MMMM YYYY"
        />
      </ACol>
      <ACol
        v-if="hasRoles([ROLE_ADMIN_BK, ROLE_HELPDESK, ROLE_ASM, ROLE_SPC, ROLE_SPC_TARGET])"
        :xl="6"
        :md="8"
        :sm="12"
        :span="24"
      >
        <ASelect
          style="width:100%;"
          v-model:value="state.params.status"
          show-search
          allow-clear
          placeholder="Pilih Status"
          :options="state.statusLists"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AButton type="primary" title="cari" @click="refreshFetch()" :loading="state.isFetching">
          <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
          <span v-else>
            Memuat Data ...
          </span>
        </AButton>
      </ACol>
    </ARow>

    <AForm
      ref="formRefTable"
      class="myform"
      :model="form"
      :rules="state.rules"
      @finish="actionChecked"
      :wrapper-col="{ span: 14 }"
      :scroll-to-first-error="true"
    >
      <div class="row justify-content-end mt-4">
        <div class="col-lg-6 col-md-12 mt-auto">
          <div v-if="hasRoles([ROLE_TSO, ROLE_ASM, ROLE_SPC])">
            <p>Approve: {{ state.action.approve }}</p>
            <p>Reject: {{ state.action.reject }}</p>
            <p>Delete: {{ state.action.delete }}</p>
            <p>Sisa: {{ state.action.remaining }}</p>
          </div>
          <p>Sinkron terakhir: {{ state.action.lastTime }}</p>
        </div>
        <div class="col-lg-6 col-md-12 text-right mt-auto">
          <ASpace>
            <!-- Note: button Simpan digunakan sebagai submit -->
            <ATooltip v-if="hasRoles([ROLE_TSO, ROLE_ASM, ROLE_SPC])" title="Simpan">
              <AButton
                type="primary"
                html-type="submit"
                :disabled="!state.action.button"
                :loading="state.action.loading"
              >
                Simpan
              </AButton>
            </ATooltip>
            <ATooltip
              v-if="state.isDisableUpload && hasRoles([ROLE_TSO, ROLE_ASM, ROLE_SPC])"
              title="Upload Dokumen"
              placement="left"
            >
              <AButton type="primary" @click="btnUpload">
                <i class="fa fa-upload" aria-hidden="true"></i>
              </AButton>
            </ATooltip>
            <ATooltip title="Download Excel" placement="left">
              <DownloadExcel
                :url="state.endpoint.current"
                :params="queryParams()"
                @errors="errorMessage"
              />
            </ATooltip>
            <ATooltip title="Download Excel Detail Transaksi" placement="left">
              <AButton
                type="primary"
                @click="btnDownloadExcelRaw"
                :loading="state.isDownloadingRaw"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true" v-if="!state.isDownloadingRaw"></i>
                <span v-else>Downloading ...</span>
              </AButton>
            </ATooltip>
          </ASpace>
        </div>
      </div>

      <!-- list table -->
      <div class="table-responsive text-nowrap mt-4">
        <MdTable
          :columns="state.columns"
          :data-source="state.data"
          size="small"
          :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
          :pagination="{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
            showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
            total: state.meta.total,
            pageSize: state.meta.per_page,
            current: state.meta.page,
          }"
          @change="handleTableChange"
          :loading="state.isFetching"
        >
          <template #no="{ index }">
            <span>
              {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
            </span>
          </template>

          <template #action="{ index, text }">
            <ARadioGroup
              v-model:value="text.action_status"
              @input="listenActionButton($event, text.suggestion_id, index)"
              :key="index"
            >
              <ASpace>
                <!--
                                    action_button_request digunakan untuk disable button ketika
                                    TSO reject item ke ASM -->
                <ATooltip title="Approve">
                  <ARadioButton
                    class="approve"
                    shape="circle"
                    :id="text.suggestion_id"
                    :disabled="!text.action_button_request"
                    value="approve"
                  >
                    <i class="fa fa-check" aria-hidden="true" />
                  </ARadioButton>
                </ATooltip>
                <ATooltip title="Reject">
                  <ARadioButton
                    class="reject"
                    shape="circle"
                    :id="text.suggestion_id"
                    :disabled="!text.action_button_request"
                    value="reject"
                  >
                    <i class="fa fa-times" aria-hidden="true" />
                  </ARadioButton>
                </ATooltip>
                <ATooltip v-if="text.role_action_delete" title="Delete">
                  <ARadioButton
                    class="delete"
                    shape="circle"
                    :id="text.suggestion_id"
                    value="delete"
                    :disabled="!text.action_button_request"
                  >
                    <i class="fa fa-trash" aria-hidden="true" />
                  </ARadioButton>
                </ATooltip>
              </ASpace>
            </ARadioGroup>
          </template>

          <template #category="{ index, text }">
            <AFormItem :name="['children', index, 'category']">
              <FilterSuggestionHeader
                style="width:350px;"
                :mode="null"
                :disabled="!text.isAction"
                :group="text.header_group"
                @change="listenActionCategory($event, text.suggestion_id, index)"
                v-model:value="text.category"
              />
            </AFormItem>
          </template>

          <template #upload="{ index, text }">
            <AFormItem :name="['children', index, 'file']">
              <AUpload
                accept="application/pdf"
                :before-upload="file => listenBeforeUpload(file, index)"
                :file-list="text.file"
                :max-count="1"
                :disabled="!text.isUpload"
              >
                <ATooltip :title="text.isUpload ? state.approve_notes[text.action_status] : ''">
                  <AButton :disabled="!text.isUpload"> <UploadOutlined />Pilih File </AButton>
                </ATooltip>
              </AUpload>
            </AFormItem>

            <iframe v-if="text.image_url" :src="text.image_url" width="100%" />
          </template>

          <template #note="{ index, text }">
            <AFormItem :name="['children', index, 'note']">
              <ATextarea
                v-model:value="text.note"
                :key="index"
                placeholder="note"
                allow-clear
                style="width:200px;"
                :disabled="!text.isAction"
                @input="listenActionNote($event, text.suggestion_id, index)"
              />
            </AFormItem>
          </template>
        </MdTable>
      </div>
    </AForm>

    <!-- upload -->
    <Upload
      v-if="visibleUploadModal"
      v-model:visible="visibleUploadModal"
      @success="fetchDataList"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, h } from 'vue'
import apiClient from '@/services/axios'
import FilterOpco from '@/components/filter/FilterOpco'
import { Modal, message } from 'ant-design-vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterArea from '@/components/filter/FilterArea'
import FilterToko from '@/components/filter/FilterToko'
import FilterSuggestionHeader from '@/components/filter/FilterSuggestionHeader'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import Form from 'vform'
import Upload from './Upload'
import _ from 'lodash'
import {
  ROLE_ADMIN_BK,
  ROLE_ASM,
  ROLE_TSO,
  ROLE_SPC,
  ROLE_HELPDESK,
  ROLE_SPC_TARGET,
  hasRoles,
} from '@/helpers'
import moment from 'moment'
import includes from 'lodash/includes'
import sumBy from 'lodash/sumBy'
import store from 'store'
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'
import dbIndexClient from '@/helpers/dbIndexClient'

export default defineComponent({
  components: {
    UploadOutlined,
    FilterProvince,
    FilterKabupatenKota,
    FilterDistributor,
    FilterOpco,
    FilterArea,
    FilterToko,
    FilterSuggestionHeader,
    DownloadExcel,
    Upload,
  },
  setup() {
    const errorMessage = ref()

    const formRef = ref()
    const formRefTable = ref()

    const form = reactive(
      new Form({
        children: [],
      }),
    )

    const dbClient = dbIndexClient.initDB('storages')

    const state = reactive({
      columnBackup: [],
      columns: [
        {
          title: 'NO',
          slots: { customRender: 'no' },
        },
        {
          title: 'Action',
          key: 'action', // key alias dataIndex untuk validasi kolom
          slots: { customRender: 'action' },
        },
        {
          title: 'Kategori',
          width: 200,
          key: 'category',
          slots: { customRender: 'category' },
        },
        {
          title: 'Upload',
          width: 200,
          key: 'upload',
          slots: { customRender: 'upload' },
        },
        {
          title: 'Note',
          width: 200,
          key: 'note',
          slots: { customRender: 'note' },
        },
        {
          title: 'Periode',
          dataIndex: 'periode',
        },
        {
          title: 'ID Toko',
          dataIndex: 'customer_code',
        },
        {
          title: 'Nama Toko',
          dataIndex: 'customer_name',
        },
        {
          title: 'Area AP Toko',
          dataIndex: 'opco_toko',
        },
        {
          title: 'Alamat',
          dataIndex: 'address',
        },
        {
          title: 'Area',
          dataIndex: 'area',
        },
        {
          title: 'Kota',
          dataIndex: 'city',
        },
        {
          title: 'Provinsi',
          dataIndex: 'province',
        },

        {
          title: 'SSM',
          dataIndex: 'user_ssm',
        },
        {
          title: 'ASM',
          dataIndex: 'user_sm',
        },
        {
          title: 'TSO',
          dataIndex: 'user_am',
        },
        {
          title: 'Distributor Mapping',
          dataIndex: 'distributor_mapping',
        },
        {
          title: 'Average Volume Toko (2 Bulan)',
          dataIndex: 'avg_volume',
        },
        {
          title: 'Status',
          dataIndex: 'status_approval',
        },
        {
          title: 'Kategori',
          dataIndex: 'category',
        },
        {
          title: `Catatan ${hasRoles([ROLE_ASM]) ? 'TSO' : 'ASM'}`,
          dataIndex: 'rejection_note',
        },
        // {
        //     title: '',
        //     slots: { customRender: 'action' },
        // },
      ],
      endpoint: {
        current: '/api/report-lelang/suggestion',
        submit: `/api/report-lelang/approval`,
      },
      data: [],
      meta: {
        per_page: 10,
        page: 1,
        total: 0,
      },
      isFetching: false,
      isDownloading: false,
      isDownloadingRaw: false,
      params: extractQueryParams({
        q: '',
        opco: [],
        provinsi: [],
        distributor: [],
        area: [],
        kabupaten: [],
        toko: [],
        status: null,
        periode: moment(new Date())
          .startOf('month')
          .format('YYYY-MM'),
        page: 1,
        'per-page': 10,
      }),
      selectedRows: [],
      selectedRowKeys: [],
      formStatus: {
        reject_note: '',
      },
      statusLists: [
        {
          label: 'Awaiting/suggest lelang',
          value: 1,
        },
        {
          label: 'Approve level 1 (tso)',
          value: 2,
        },
        {
          label: 'Reject level 1 (tso)',
          value: 3,
        },
        {
          label: 'Approve level 2 (asm)',
          value: 4,
        },
        {
          label: 'Reject level 2 (asm)',
          value: 5,
        },
      ],
      action: {
        loading: false,
        button: false,
        storages: [],
        approve: 0,
        reject: 0,
        delete: 0,
        remaining: 0,
        lastTime: '',
        disableAction: false,
      },
      isDisableUpload: true,
      rules: {
        children: [],
      },
      rule_references: {
        file: [
          {
            required: false,
            message: 'File tidak boleh kosong!',
          },
        ],
        category: [
          {
            required: false,
            message: 'Kategori tidak boleh kosong!',
          },
        ],
        note: [
          {
            required: false,
            message: 'Catatan tidak boleh kosong!',
          },
        ],
      },
      category_headers: {
        approve: 'SUGGESTION_APPROVE',
        reject: 'SUGGESTION_REJECT',
        delete: 'SUGGESTION_DELETE',
      },
      approve_notes: {
        approve:
          'Wajib mencantumkan Berita Acara beserta Invoice Piutang Distributor  (format PDF).',
        reject:
          'Wajib mencantumkan Berita Acara beserta Invoice Piutang Distributor  (format PDF).',
        delete:
          'Wajib mencantumkan Berita Acara beserta foto yang dilengkapi dengan Geotagging dan Time Stamp (format PDF).',
      },
    })

    const onSelectChange = (keys, rows) => {
      state.selectedRowKeys = keys
      state.selectedRows = rows
    }

    const handleTableChange = (page, filters, sorter) => {
      state.params.page = page.current
      state.params['per-page'] = page.pageSize

      refreshFetch()
    }

    const queryParams = () => {
      let params = state.params

      if (state.params.periode) {
        params.periode = moment(state.params.periode).format('YYYY-MM')
      }

      return updateUrlWithQuery(params)
    }

    const refreshFetch = () => {
      fetchDataList()
      fetchSynchron()
      fetchClosePeriode()
    }

    // fetch list data
    const fetchDataList = () => {
      state.isFetching = true

      apiClient
        .get(state.endpoint.current, {
          params: queryParams(),
        })
        .then(({ data }) => {
          const { items, _meta } = data

          items.forEach((item, i) => {
            item.key = i
            item['progress_download'] = false
            // only role am
            item.role_action_delete = hasRoles([ROLE_TSO])
            // validation upload by delete action
            item.isUpload = false
            // set default action status
            item.isAction = false

            // hanya membalidasi pada first item saja sudah cukup
            if (i == 0) {
              state.columns = state.columnBackup
              state.action.disableAction =
                item.action_button || moment(item.periode).isSame(new Date(), 'month')
              validateRole()
            }

            // validate file submit
            state.rules.children.push(
              Object.assign(
                {},
                {
                  ...state.rule_references,
                  suggestion_id: item.suggestion_id,
                },
              ),
            )
            form.children.push(Object.assign({}, { file: null }))
          })

          state.data = items
          state.meta.page = _meta.currentPage
          state.meta.per_page = _meta.perPage
          state.meta.total = _meta.totalCount

          // TODO: comment test
          if (state.meta.total) {
            loadActionStorage()
          } else {
            resetActionStorage()
          }
        })
        .finally(() => {
          state.isFetching = false
        })
    }

    // fetch synchron
    const fetchSynchron = () => {
      apiClient
        .get(state.endpoint.current, {
          params: {
            ...queryParams(),
            _data: 'synchron',
          },
        })
        .then(({ data }) => {
          state.action.lastTime = data.last_synchron
        })
    }

    // fetch close periode
    const fetchClosePeriode = () => {
      apiClient
        .get('/api/synchron-open/cek', {
          params: {
            periode: moment(state.params.periode).format('YYYY-MM'),
          },
        })
        .then(({ data }) => {
          state.isDisableUpload = data.openClosePriode
        })
    }

    // download export excel raw
    const btnDownloadExcelRaw = () => {
      state.isDownloadingRaw = true
      apiClient
        .get(state.endpoint.current, {
          params: {
            ...queryParams(),
            _export: 'xls-raw',
          },
          responseType: 'blob',
          headers: {},
        })
        .then(response => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `Laporan-Suggestion-Toko-Lelang_${moment().format('DDMMYY_HHmm')}_Raw.xlsx`,
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(async error => {
          errorMessage.value = null
          if (error.response) {
            const { status, statusText } = error.response
            const message = JSON.parse(await error.response.data.text()).message
            errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
          }
        })
        .finally(() => {
          state.isDownloadingRaw = false
        })
    }

    const actionChecked = () => {
      Modal.confirm({
        title: 'Perhatian:',
        content: h('div', {}, [
          h(
            'p',
            'Tindakan Approve/Reject yang akan Anda lakukan akan langsung terproses. Apabila ada kesalahan, maka toko-toko terkait tidak akan muncul kembali di Menu Suggestion Toko Lelang hingga periode bulan berikutnya.',
          ),
          h('br'),
          h('strong', 'Pastikan data sudah benar. Apakah Anda yakin untuk melanjutkan?'),
        ]),
        onOk() {
          const payloads = new FormData()

          for (let [index, item] of Object.entries(state.action.storages)) {
            payloads.append(`${item.status}[${index}][suggestion_id]`, item.id)
            payloads.append(`${item.status}[${index}][header]`, item.category || '')
            payloads.append(`${item.status}[${index}][note]`, item.note || '')
            payloads.append(`${item.status}[${index}][status]`, item.status_approval_code)

            let firstFile = form.children.find(v => v.id == item.id)
            if (firstFile) {
              payloads.append(`${item.status}[${index}][image]`, firstFile.file)
            }
          }

          state.action.loading = true
          apiClient
            .post(state.endpoint.submit, payloads)
            .then(({ data }) => {
              refreshFetch()
              message.success(data.message.approve)
              message.success(data.message.reject)
              message.success(data.message.delete)

              // reset localstorage
              resetActionStorage()
            })
            .catch(e => message.error('Gagal mengirim status!'))
            .finally(() => {
              state.action.loading = false
            })
        },
      })
    }

    const listenActionButton = (event, id, index) => {
      let status = event.target.value

      let find = state.action.storages.find(item => item.id == id)
      let first = state.data.find(item => item.suggestion_id == id)

      if (find) {
        find.status = status
        find.status_approval_code = first.status_approval_code

        // reset category ketika change action
        find.category = null
        first.category = null
        form.children[index].category = null
      } else {
        state.action.storages.push({
          id: id,
          status: status,
          status_approval_code: first.status_approval_code,
        })
      }

      let isDelete = status == 'delete'

      // change validation file
      ChangeRuleValidation(id, status)

      // jika selain delete maka file data akan di reset
      if (!isDelete) {
        first.file = null
        first.image_url = null
        first.image = null

        // reset form agar file field null, agar inputan file bisa ke change
        _.forEach(form.children, item => {
          if (item.id === id) {
            item.file = null
          }
        })
      }

      // for enabled upload input only reject and delete
      first.isUpload = _.includes(['reject', 'delete'], status)

      // add category group for suggestion category
      first.header_group = state.category_headers[status]

      // set action status
      first.isAction = true

      state.action.approve = sumBy(state.action.storages, item => +(item.status == 'approve'))
      state.action.reject = sumBy(state.action.storages, item => +(item.status == 'reject'))
      state.action.delete = sumBy(state.action.storages, item => +(item.status == 'delete'))

      state.action.button = state.action.storages.length > 0
      state.action.remaining = state.meta.total - state.action.storages.length

      localStorage.setItem(_prefixUser('action_data'), JSON.stringify(state.action.storages))
      localStorage.setItem(_prefixUser('action_approve'), state.action.approve)
      localStorage.setItem(_prefixUser('action_reject'), state.action.reject)
      localStorage.setItem(_prefixUser('action_delete'), state.action.delete)
    }

    const listenBeforeUpload = async (file, index) => {
      let first = state.data.find((item, i) => i == index)
      let url = URL.createObjectURL(file)

      if (first && url) {
        first.image_url = url
        first.image = file
        form.children[index].file = file
        form.children[index].id = first.suggestion_id

        // save file in indexDB
        const findFile = await dbClient.store('files').find(x => x.id === first.suggestion_id)
        const fileSave = {
          id: first.suggestion_id,
          uid: file.uid,
          name: file.name,
          type: file.type,
          blob: file.slice(),
        }

        if (findFile) {
          // update file
          dbClient.store('files').update(fileSave)
        } else {
          // create new file
          dbClient.store('files').create(fileSave)
        }
      }

      return false
    }

    const listenActionNote = ({ target }, id, index) => {
      let find = state.action.storages.find(item => item.id == id)
      if (find) {
        find.note = target.value
      } else {
        state.action.storages.push({
          id,
          note: target.value,
        })
      }

      form.children[index].note = target.value
      localStorage.setItem(_prefixUser('action_data'), JSON.stringify(state.action.storages))
    }

    const listenActionCategory = (value, id, index) => {
      let find = state.action.storages.find(item => item.id == id)
      let first = state.data.find(item => item.suggestion_id == id)
      if (find) {
        find.category = value
      } else {
        state.action.storages.push({
          id,
          category: value,
        })
      }

      if (first && first.action_status == 'approve') {
        let isUploadCategory = value == 'Bad Debt'
        first.isUpload = isUploadCategory // only category 1 (Bad Debt) is upload
        ChangeRuleValidation(id, first.action_status, value)

        // reset file when category is not upload
        if (!isUploadCategory) {
          first.image_url = null
          first.image = null
          form.children[index].file = null

          // delete file in indexDB
          dbClient.store('files').delete(id)
        }
      }

      form.children[index].category = value
      localStorage.setItem(_prefixUser('action_data'), JSON.stringify(state.action.storages))
    }

    const ChangeRuleValidation = (id, status, keyCategory = null) => {
      // Buat payload baru yang mencakup hanya data yang perlu diubah
      const updatedRules = state.rules.children.map(rule => {
        if (rule.suggestion_id === id) {
          return {
            ...rule,
            file: rule.file.map(fileItem => ({
              ...fileItem,
              required: status != 'approve' || (keyCategory != null && keyCategory == 'Bad Debt'), // only required delete and reject action or category 1 (Bad Debt)
            })),
            category: rule.category.map(categoryItem => ({
              ...categoryItem,
              required: true,
            })),
            note: rule.note.map(noteItem => ({
              ...noteItem,
              required: true,
            })),
          }
        }
        return rule // Biarkan data lain tidak berubah
      })

      // Replace semua data dengan payload baru
      state.rules.children = updatedRules
    }

    const loadActionStorage = async () => {
      state.data.forEach(async (item, index) => {
        let find = state.action.storages.find(i => i.id == item.suggestion_id)
        if (find) {
          item.action_status = find.status
          item.note = find.note
          item.category = find.category
          // save form category and note untuk mengecekan validasi
          form.children[index].category = find.category
          form.children[index].note = find.note

          // true: aktifkan button upload input only reject and delete
          const isFileStatus = _.includes(['reject', 'delete'], find.status)
          if (isFileStatus) {
            item.isUpload = isFileStatus
          }

          if (find.status == 'approve') {
            item.isUpload = find.category == 'Bad Debt' // only category 1 (Bad Debt) is upload
          }

          // change validation children (akan melakikan validasi file and category)
          ChangeRuleValidation(item.suggestion_id, find.status, find.category)

          // add category group for suggestion category
          item.header_group = state.category_headers[find.status]

          // set action status
          item.isAction = true
        }

        // set file blob from dbIndex
        const file = await dbClient.store('files').find(x => x.id === item.suggestion_id)

        if (file) {
          const blob = new Blob([file.blob], { type: file.type })
          const url = URL.createObjectURL(blob)
          item.image_url = url
          item.image = file.blob
          form.children[index].file = blob
          form.children[index].id = item.suggestion_id
        }
      })

      if (localStorage.getItem(_prefixUser('action_approve'))) {
        state.action.approve = localStorage.getItem(_prefixUser('action_approve'))
      }

      if (localStorage.getItem(_prefixUser('action_reject'))) {
        state.action.reject = localStorage.getItem(_prefixUser('action_reject'))
      }

      if (localStorage.getItem(_prefixUser('action_delete'))) {
        state.action.delete = localStorage.getItem(_prefixUser('action_delete'))
      }

      state.action.button = state.action.storages.length > 0
      state.action.remaining = state.meta.total - state.action.storages.length
    }

    const resetActionStorage = () => {
      state.action = {
        button: false,
        storages: [],
        approve: 0,
        reject: 0,
        delete: 0,
        remaining: 0,
      }

      localStorage.removeItem(_prefixUser('action_data'))
      localStorage.removeItem(_prefixUser('action_approve'))
      localStorage.removeItem(_prefixUser('action_reject'))
      localStorage.removeItem(_prefixUser('action_delete'))

      // clear indexDB storage
      dbClient.store('files').clear()
    }

    const _prefixUser = name => {
      const user = store.get('profile')
      return `${user.id}_${name}`
    }

    const disabledDateMonthFilter = current => {
      return current && current > moment()
    }

    const validateRole = () => {
      // validation list status for a ASM role
      if (hasRoles([ROLE_ASM, ROLE_SPC])) {
        state.statusLists = state.statusLists.filter(item => {
          if (includes([2, 3], item.value)) {
            return item
          }
        })
      } else {
        // column category only role ASM, SPC
        state.columns = state.columns.filter(item => {
          if (!includes(['category'], item.dataIndex)) {
            return item
          }
        })
      }

      if (hasRoles([ROLE_TSO])) {
        state.columns = state.columns.filter(item => {
          if (!includes(['rejection_note', 'status_approval'], item.dataIndex)) {
            return item
          }
        })
      }

      // state.action.disableAction digunakan untuk menghilangkan action kolom saat bulan selanjutnya
      // Note: jika menggunakan ket dataIndex maka kolom action akan error (Cannot read properties of undefined (reading 'action_status'))
      if (hasRoles([ROLE_ADMIN_BK, ROLE_HELPDESK]) || !state.action.disableAction) {
        state.columns = state.columns.filter(item => {
          if (!includes(['action', 'category', 'note', 'upload'], item.key)) {
            return item
          }
        })
      }

      if (hasRoles([ROLE_ADMIN_BK, ROLE_HELPDESK])) {
        state.statusLists = state.statusLists.filter(item => {
          if (includes([1, 2, 3], item.value)) {
            return item
          }
        })
      }

      // validasi kolom hanya di lihat di role TSO saja
      if (!hasRoles([ROLE_TSO])) {
        state.columns = state.columns.filter(item => {
          if (!includes(['category', 'upload'], item.key)) {
            return item
          }
        })
      }
    }

    // handle upload
    const visibleUploadModal = ref(false)

    const btnUpload = () => {
      visibleUploadModal.value = true
    }

    // handle vue
    onMounted(() => {
      state.columnBackup = state.columns

      if (localStorage.getItem(_prefixUser('action_data'))) {
        state.action.storages = JSON.parse(localStorage.getItem(_prefixUser('action_data')))
      }

      refreshFetch()

      // validate role
      validateRole()
    })

    return {
      state,
      handleTableChange,
      onSelectChange,
      btnDownloadExcelRaw,
      errorMessage,
      queryParams,
      actionChecked,
      listenActionNote,
      listenActionButton,
      refreshFetch,
      disabledDateMonthFilter,
      visibleUploadModal,
      btnUpload,
      listenBeforeUpload,
      listenActionCategory,
      formRef,
      formRefTable,
      form,
      hasRoles,
      ROLE_ADMIN_BK,
      ROLE_HELPDESK,
      ROLE_ASM,
      ROLE_TSO,
      ROLE_SPC,
      ROLE_SPC_TARGET,
    }
  },
})
</script>

<style scoped lang="scss">
.approve,
.reject,
.delete {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50% !important;

  &.ant-radio-button-wrapper-checked {
    color: white !important;
  }
}
.approve {
  padding: 0px 8px !important;
  color: #009688;

  &.ant-radio-button-wrapper-checked {
    background-color: #009688 !important;
    border-color: #009688 !important;
  }
}
.reject {
  padding: 0px 10px !important;
  color: #f44336;

  &.ant-radio-button-wrapper-checked {
    background-color: #f44336 !important;
    border-color: #f44336 !important;
  }
}
.delete {
  padding: 0px 10px !important;
  color: #9e9e9e;

  &.ant-radio-button-wrapper-checked {
    background-color: #9e9e9e !important;
    border-color: #9e9e9e !important;
  }
}
.ant-form-item {
  margin-bottom: 0px !important;
}
</style>
